import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/crew.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { CrewService } from '../services/crew.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setUnitEquipmentOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const crewService = new CrewService(serviceId)
  try {
    const response: IOptionsResponse = yield call([crewService, crewService.getUnitEquipmentOptions])
    const { entity } = response
    if (entity) {
      yield put(actions.setUnitEquipmentOptions(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`setUnitEquipmentOptions() error: ${e}`))
  }
}
export function* setUnitEquipmentOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setUnitEquipmentOptions)
}
